
import Vue from "vue";
import clip from "text-clipper";

// eslint-disable-next-line
const Truncate: any = Vue.extend({
  name: "MyTruncate",
  props: {
    truncated: {
      type: Boolean,
      default: false,
    },
    collapsedTextClass: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      required: true,
    },
    clamp: {
      type: String,
      default: "Read More",
    },
    length: {
      type: Number,
      default: 100,
    },
    less: {
      type: String,
      default: "Show Less",
    },
    type: {
      type: String,
      default: "text",
    },
    actionClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    isHTML() {
      return this.type === "html";
    },
    textClass() {
      return (this as any).textLength > this.length && this.collapsedTextClass
        ? this.collapsedTextClass
        : "";
    },
    textLength() {
      if (this.isHTML) {
        // We need the length of the text without the html being considered
        // This ensures we provide the right calculation for when to show/hide the more link
        const text = this.text.replace(/<[^>]*>/g, "");
        return text.length;
      }
      return this.text.length;
    },
    showToggle() {
      return (this as any).textLength > this.length;
    },
  },
  created() {
    this.show = this.truncated;
  },
  methods: {
    truncate(text: string): string {
      if (text) {
        if (this.type === "html") {
          try {
            return clip(text, this.length, {html: true, maxLines: 10, stripTags: ["img", "svg"]});
          }catch (e) {
            return text;
          }
        }
        return clip(text, this.length);
      }
      return "";
    },
    toggle(override: boolean) {
      // use the override value if it is set as a boolean
      const toggled = typeof override === "boolean" ? override : !this.show;
      this.show = toggled;
    },
  },
});

export default Truncate;
